import React, { useState } from 'react';
import useCustomerEmails from '../hooks/use-customer-emails';
import useOneWayIn from '../../hooks/use-one-way-in';
import { Navigate, useParams } from 'react-router-dom';
import { PageParams } from '../types/PageParams';
import { Button } from '@innovationnorway/component-library';
import CreateEmailThreadModal from '../components/customer-communication/CreateEmailThreadModal';
import { useAuth } from 'src/features/authorization';
import NoAccess from 'src/components/NoAccess/NoAccess';
import { useTranslation } from 'react-i18next';
import { ONE_WAY_IN_DETAILS } from '../routes';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';

const OldCustomerCommunication: React.FC = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInOpportunityById, oneWayInGroupedFormWOEnrollmentsQuery } = useOneWayIn(formId);
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { threads } = useCustomerEmails(oneWayInOpportunityById.data?.id ?? '');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { checkAccess } = useAuth();
  const { read, write } = checkAccess('OneWayInCustomerCommunication');

  if (!read) {
    return <NoAccess />;
  }

  if (oneWayInOpportunityById.isInitialLoading || oneWayInGroupedFormWOEnrollmentsQuery.isInitialLoading) {
    return <LoadingPage />;
  }

  if (threads != null && threads.length != 0) {
    //redirect to the first thread
    const firstThread = threads[0];
    return <Navigate to={ONE_WAY_IN_DETAILS.CUSTOMER_COMMUNICATION_THREAD(formId!, firstThread.numericId)} />;
  }

  return (
    <div className="stack">
      <h2>{tOneWayIn('communication.sendEmailToCustomer')}</h2>
      <p>
        Vi jobber med å endre avsenderadressen for e-postene som sendes fra Flerbedriftsportalen. Foreløpig er
        adressen <u>kundemottak@enveiinn.no</u>.
      </p>
      <p>
        Kunder kan ikke se tidligere meldinger i e-posten, men de kan fortsatt svare direkte på e-posten du
        har sendt dem via Flerbedriftsportalen.
      </p>
      <p>
        Vi gjør løpende forbedringer i løsningen. Har du innspill eller spørsmål, hører vi gjerne fra deg.
      </p>
      <p>Takk for tålmodigheten!</p>
      <Button type="button" onClick={() => setIsModalOpen(true)} disabled={!write}>
        {tOneWayIn('communication.sendEmail')}
      </Button>
      {isModalOpen && write && (
        <CreateEmailThreadModal
          formId={formId}
          show={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          opportunity={oneWayInOpportunityById.data}
          groupedForm={oneWayInGroupedFormWOEnrollmentsQuery.data}
        />
      )}
    </div>
  );
};

export default OldCustomerCommunication;
